import { FootprintShapeType, PositionType } from 'data/types';
import { footprintBoundingBox } from 'utils/footprint-polygons';
import { footprintShapesToPoints } from 'utils/footprint-union';

export const PRESET_SHAPE_GAP_FEET = 4;

export function resolvePresetShapeTarget(
  shape: PositionType[],
  existingShapes: FootprintShapeType[],
  imageCenter: PositionType | null
): PositionType {
  const existingBounds = footprintBoundingBox(
    footprintShapesToPoints(existingShapes)
  );
  if (!existingBounds) {
    return imageCenter ?? { x: 0, y: 0 };
  }
  const xs = shape.map((p) => p.x);
  const shapeWidth = Math.max(...xs) - Math.min(...xs);
  return {
    x: existingBounds.maxX + PRESET_SHAPE_GAP_FEET + shapeWidth / 2,
    y: (existingBounds.minY + existingBounds.maxY) / 2
  };
}
